/**
 * Initial state for company form
 */
export const COMPANY_FORM_INITIAL_STATE = {
  legalName: '',
  rut: '',
  name: '',
  format: '',
  specialty: '',
  region: '',
  comuna: '',
  numberOfRestaurants: '',
  workers: '',
  weeklyAverageClients: '',
  profileImageUrl: '',
  description: '',
  benefits: {
    seguro: false,
    traslado: false,
    uniforme: false,
    capacitación: false,
    colación: false,
    formación: false,
    cumpleañosLibre: false,
    conveniosExternos: false,
    descuentosCorporativos: false,
    contratosCorporativos: false,
    otras: false
  },
  locations: [{ address: "", latitude: "", longitude: "" }],
  profileCarouselUrls: [],
};

/**
 * Benefit options for the form
 */
export const BENEFIT_OPTIONS = [
  { key: 'seguro', label: 'Seguro' },
  { key: 'traslado', label: 'Traslado' },
  { key: 'uniforme', label: 'Uniforme' },
  { key: 'capacitación', label: 'Capacitación' },
  { key: 'colación', label: 'Colación' },
  { key: 'formación', label: 'Formación' },
  { key: 'cumpleañosLibre', label: 'Cumpleaños Libre' },
  { key: 'conveniosExternos', label: 'Convenios Externos' },
  { key: 'descuentosCorporativos', label: 'Descuentos Corporativos' },
  { key: 'contratosCorporativos', label: 'Contratos Corporativos' },
  { key: 'otras', label: 'Otras' }
];

/**
 * Chilean regions
 */
export const CHILEAN_REGIONS = [
  "Arica y Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo",
  "Valparaíso", "O'Higgins", "Maule", "Ñuble", "Biobío", "La Araucanía",
  "Los Ríos", "Los Lagos", "Aysén", "Magallanes", "Metropolitana"
];

/**
 * Santiago communes
 */
export const SANTIAGO_COMMUNES = [
  "Estación Central", "Huechuraba", "La Florida", "La Pintana", "Las Condes",
  "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "Ñuñoa",
  "Pedro Aguirre Cerda", "Peñalolén", "Providencia", "Pudahuel", "Quilicura",
  "Quinta Normal", "Recoleta", "Renca", "San Joaquín", "San Miguel",
  "San Ramón", "Santiago", "Vitacura"
];
